import { api, formatToLocalDate } from '@/utils';
import DossierOverviewTableInputProduct from '../DossierOverviewTableInputProduct/DossierOverviewTableInputProduct.vue';

export default {
  name: 'DossierOverviewTableInputs',
  components: {
    DossierOverviewTableInputProduct,
  },
  props: {
    dossierObj: {},
  },
  data: () => ({
    page: 1,
    inputs: [],
    nominationInputs: [],
    shippingAgentInputs: [],
    arrivalInputs: [],
    departureInputs: [],
    productInputs: [],
    loading: true,
    showInputLog: false,
    logInputs: [],
    logTitle: '',
    logHeaders: [
      { text: 'Job date', value: 'jobDate' },
      { text: 'Created', value: 'created' },
      { text: 'ET start', value: 'beginEstimate' },
      { text: 'AT start', value: 'beginActual' },
      { text: 'ET end', value: 'endEstimate' },
      { text: 'AT end', value: 'endActual' },
      { text: '', value: 'buttons' },
    ],
  }),
  computed: {},
  methods: {
    fetchInputs() {
      this.loading = true;
      const url = `/inputs?page=${this.page}&page-size=999&dossier=${this.dossierObj.id}`;
      api
        .get(url)
        .then((response) => {
          if (response.data.length <= 0) {
            this.snackbar = true;
            this.snackbarText = 'No (more) inputs found.';
          }
          response.data.forEach((input) => {
            const formattedDate = formatToLocalDate(input.createdOn);

            const obj = {
              id: input.id,
              typeInput: input.inputType,
              companyId: input.assigneeStakeholder.id,
              companyReference: input.assigneeStakeholder.reference,
              companyName: input.assigneeStakeholder.name,
              sourceCompanyId: input.sourceStakeholder.id,
              sourceReference: input.sourceStakeholder.reference,
              sourceCompanyName: input.sourceStakeholder.name,
              source: input.sourceType,
              created: formattedDate,
              jobDate: formatToLocalDate(input.jobDate),
              latestCargo: input.cargo[input.cargo.length - 1],
              stayNumber: this.dossierObj.stayNumber,
              voyageNumber: this.dossierObj.voyageNumber,
              beginEstimate: formatToLocalDate(input.dateTimeWindow1.beginEstimate),
              endEstimate: formatToLocalDate(input.dateTimeWindow1.endEstimate),
              beginActual: formatToLocalDate(input.dateTimeWindow1.beginActual),
              endActual: formatToLocalDate(input.dateTimeWindow1.endActual),
              clientId: this.dossierObj.clientId,
            };

            if (input.inputType === 'Nomination') {
              obj.beginActual = formatToLocalDate(input.dateTimeWindow2.beginEstimate);
              obj.endActual = formatToLocalDate(input.dateTimeWindow2.endEstimate);
            }

            this.inputs.push(obj);
            switch (input.inputType) {
              case 'Nomination':
                this.nominationInputs.push(obj);
                break;
              case 'ShippingAgent':
                this.shippingAgentInputs.push(obj);
                break;
              case 'PortEngineArrival':
                this.arrivalInputs.push(obj);
                break;
              case 'PortEngineDeparture':
                this.departureInputs.push(obj);
                break;
              default:
                break;
            }

            if (input.cargo.length > 0) {
              input.cargo.forEach((cargo) => {
                let armConnectedEvents = [];
                let armDisconnectedEvents = [];
                let pausedEvents = [];
                let resumedEvents = [];
                cargo.activityEvents.forEach((activity) => {
                  switch (activity.activityEventType) {
                    case 'CargoOperationsCargoArmConnected':
                      armConnectedEvents.push(activity);
                      break;
                    case 'CargoOperationsCargoArmDisconnected':
                      armDisconnectedEvents.push(activity);
                      break;
                    case 'CargoOperationsPaused':
                      pausedEvents.push(activity);
                      break;
                    case 'CargoOperationsResumed':
                      resumedEvents.push(activity);
                      break;
                    default:
                      break;
                  }
                });
                armConnectedEvents = armConnectedEvents.sort((a, b) => new Date(b.activityEventDate) - new Date(a.activityEventDate));
                armDisconnectedEvents = armDisconnectedEvents.sort((a, b) => new Date(b.activityEventDate) - new Date(a.activityEventDate));
                pausedEvents = pausedEvents.sort((a, b) => new Date(b.activityEventDate) - new Date(a.activityEventDate));
                resumedEvents = resumedEvents.sort((a, b) => new Date(b.activityEventDate) - new Date(a.activityEventDate));

                const currentProduct = this.dossierObj.products.find(p => p.productCode === cargo.content);

                const cargoObj = {
                  inputId: input.id,
                  dossierId: this.dossierObj.id,
                  operation: cargo.operation,
                  quantity: `${cargo.quantity} ${cargo.quantityUnit != null ? cargo.quantityUnit : ''}`,
                  inputType: input.inputType,
                  beginEstimate: formatToLocalDate(cargo.operation === 'Loading' ? cargo.loadingWindow.beginEstimate : cargo.dischargeWindow.beginEstimate),
                  endEstimate: formatToLocalDate(cargo.operation === 'Loading' ? cargo.loadingWindow.endEstimate : cargo.dischargeWindow.endEstimate),
                  beginActual: formatToLocalDate(cargo.operation === 'Loading' ? cargo.loadingWindow.beginActual : cargo.dischargeWindow.beginActual),
                  endActual: formatToLocalDate(cargo.operation === 'Loading' ? cargo.loadingWindow.endActual : cargo.dischargeWindow.endActual),
                  beginEstimateVapors: formatToLocalDate(cargo.doVapors ? cargo.vaporsWindow.beginEstimate : null),
                  endEstimateVapors: formatToLocalDate(cargo.doVapors ? cargo.vaporsWindow.endEstimate : null),
                  beginActualVapors: formatToLocalDate(cargo.doVapors ? cargo.vaporsWindow.beginActual : null),
                  endActualVapors: formatToLocalDate(cargo.doVapors ? cargo.vaporsWindow.endActual : null),
                  doVapors: cargo.doVapors,
                  clientId: this.dossierObj.clientId,
                  created: formattedDate,
                  jobDate: input.jobDate,
                  companyReference: input.assigneeStakeholder.reference,
                  companyName: input.assigneeStakeholder.name,
                  armConnectedDate: armConnectedEvents[0] ? formatToLocalDate(armConnectedEvents[0].activityEventDate) : null,
                  armDisconnectedDate: armDisconnectedEvents[0] ? formatToLocalDate(armDisconnectedEvents[0].activityEventDate) : null,
                  pausedDate: pausedEvents[0] ? formatToLocalDate(pausedEvents[0].activityEventDate) : null,
                  resumedDate: resumedEvents[0] ? formatToLocalDate(resumedEvents[0].activityEventDate) : null,
                  remarks: cargo.remarks,
                };
                if (this.productInputs.some(c => c.product === cargo.content)) {
                  const productInput = this.productInputs.filter(c => c.product === cargo.content)[0];
                  productInput.inputs.push(cargoObj);
                } else if (currentProduct !== undefined) {
                  this.productInputs.push({
                    product: currentProduct.productCode,
                    name: currentProduct.productName,
                    dossierId: this.dossierObj.id,
                    inputs: [cargoObj],
                  });
                }
              });
            } else if (input.cargoProductTypes.length > 0) {
              const documentsActivities = input.activityEvents.filter(a => a.activityEventType === 'InspectionDocumentsOnBoard').sort((a, b) => new Date(b.activityEventDate) - new Date(a.activityEventDate));
              let remarks = null;
              switch (input.inputType) {
                case 'Sampling': {
                  const property = input.properties.filter(p => p.name === 'Remarks');
                  remarks = property[0] ? property[0].value : null;
                  break;
                }
                case 'Analysis': {
                  const property2 = input.properties.filter(p => p.name === 'AnalysisRemarks');
                  remarks = property2[0] ? property2[0].value : null;
                  break;
                }
                case 'Inspection': {
                  const property3 = input.properties.filter(p => p.name === 'TankRemarks');
                  remarks = property3[0] ? property3[0].value : null;
                  break;
                }
                default:
                  break;
              }
              input.cargoProductTypes.forEach((cargoProductType) => {
                const currentProductType = this.dossierObj.products.find(c => c.productCode === cargoProductType);

                const productObj = {
                  inputId: input.id,
                  operation: '',
                  quantity: '',
                  inputType: input.inputType,
                  beginEstimate: formatToLocalDate(input.dateTimeWindow1.beginEstimate),
                  endEstimate: formatToLocalDate(input.dateTimeWindow1.endEstimate),
                  beginActual: formatToLocalDate(input.dateTimeWindow1.beginActual),
                  endActual: formatToLocalDate(input.dateTimeWindow1.endActual),
                  created: formattedDate,
                  jobDate: input.jobDate,
                  companyReference: input.assigneeStakeholder.reference,
                  companyName: input.assigneeStakeholder.name,
                  clientId: this.dossierObj.clientId,
                  remarks,
                  documentsDate: documentsActivities && documentsActivities[0] ? formatToLocalDate(documentsActivities[0].activityEventDate) : null,
                };

                if (this.productInputs.some(c => c.product === cargoProductType)) {
                  const productInput = this.productInputs.filter(c => c.product === cargoProductType)[0];

                  if (currentProductType !== undefined) {
                    let name = `${currentProductType.productName}`;

                    if (currentProductType.operation) {
                      name += ` | ${currentProductType.operation}`;
                    }

                    if (currentProductType.quantity !== undefined || currentProductType.unit !== undefined) {
                      if (currentProductType.quantity !== 0 && currentProductType.unit !== null) {
                        name += ` | ${currentProductType.quantity} ${currentProductType.unit}`;
                      } else {
                        name += ' | --';
                      }
                    }

                    productInput.name = name;
                  }

                  productInput.inputs.push(productObj);
                } else if (currentProductType !== undefined) {
                  let name = `${currentProductType.productName}`;

                  if (currentProductType.operation) {
                    name += ` | ${currentProductType.operation}`;
                  }

                  if (currentProductType.quantity !== undefined || currentProductType.unit !== undefined) {
                    if (currentProductType.quantity !== 0 && currentProductType.unit !== null) {
                      name += ` | ${currentProductType.quantity} ${currentProductType.unit}`;
                    } else {
                      name += ' | --';
                    }
                  }

                  this.productInputs.push({
                    product: cargoProductType,
                    name,
                    dossierId: this.dossierObj.id,
                    inputs: [productObj],
                  });
                }
              });
            }
          });
          this.nominationInputs = this.nominationInputs.sort((a, b) => new Date(b.eventDateTime) - new Date(a.eventDateTime));
          this.shippingAgentInputs = this.shippingAgentInputs.sort((a, b) => new Date(b.eventDateTime) - new Date(a.eventDateTime));
          this.arrivalInputs = this.arrivalInputs.sort((a, b) => new Date(b.eventDateTime) - new Date(a.eventDateTime));
          this.departureInputs = this.departureInputs.sort((a, b) => new Date(b.eventDateTime) - new Date(a.eventDateTime));

          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.snackbar = true;
          this.snackbarText = error.response.data.start.join();
        });
    },
    fetchMoreInputs() {
      this.page += 1;
      this.fetchInputs();
    },
    goToDetail(input) {
      const routeData = this.$router.resolve({ name: 'input-form-with-id', params: { id: input.id } });
      window.open(routeData.href, '_blank');
    },
    addToDossier(type) {
      const routeData = this.$router.resolve({ name: 'input-form', query: { dossierId: this.dossierObj.id, type, client: this.dossierObj.clientId } });
      window.open(routeData.href, '_blank');
    },
    toggleInputLog(inputs, title) {
      this.showInputLog = true;
      this.logInputs = inputs;
      this.logTitle = title;
    },
  },
  mounted() {
    this.fetchInputs();
  },
  beforeDestroy() {
    this.inputs = [];
  },
};
